import { Controller, useFormContext } from 'react-hook-form'
import PhoneInput from 'react-phone-number-input/input'
import { useHeaders } from 'context/HeaderContext'
import { CountryCode } from 'libphonenumber-js'

interface IInputFieldPhone {
  name: 'fullName' | 'email' | 'phoneNumber'
  isContactForm?: boolean
}

const InputPhone = ({
                      name,
                      isContactForm = false,
                    }: IInputFieldPhone): JSX.Element => {
  const formContext = useFormContext()
  const { headers } = useHeaders();
  const country = (headers && headers['cf-ipcountry'] ? headers['cf-ipcountry'] : 'US') as CountryCode
  return (
    <div
      className={`float-input-container ${isContactForm ? 'contact-us' : ''}`}
    >
      <Controller
        name={name}
        control={formContext.control}
        render={({ field }) => (
          <PhoneInput
            {...field}
            country={country}
            placeholder="Phone"
            onChange={field.onChange}
          />
        )}
      />
    </div>
  )
}

export default InputPhone
